import { api } from '../../../../shared/shared.api';

export type ActualSourceKind = 'geofence' | 'driver_tap' | 'office';

/** `GET /trips/:id/timeline`, mirroring the API's view: a trip's actuals laid against its plan, recomputed from the event log on every call. */
export interface ActualSource {
  kind: ActualSourceKind;
  eventId: string;
  deviceTime: string;
  serverTime: string;
}

export interface TimelineActual {
  /** `arrived`, `loaded`, `unloaded`, `departed` or `empty_returned` on a stop; any other event type for an unplaced one. */
  milestone: string;
  at: string;
  serverAt: string;
  sources: ActualSource[];
  /** Waiting plus loading, or waiting plus offloading: the log has no "started". */
  secondsSinceArrival: number | null;
}

export interface TimelineStop {
  position: number;
  kind: 'pickup' | 'drop' | 'empty_return_depot' | 'yard';
  name: string;
  zoneCode: string | null;
  planned: { arrivalAt: string | null };
  actuals: TimelineActual[];
  /** Late is positive. */
  variance: { arrivalSeconds: number | null };
}

export interface TripTimeline {
  tripId: string;
  plan: { id: string; startAt: string | null; startedFrom: 'window' | 'dispatch' | null; drivingSeconds: number | null } | null;
  stops: TimelineStop[];
  unplaced: TimelineActual[];
}

export function getTripTimeline(tripId: string): Promise<TripTimeline> {
  return api<TripTimeline>(`/trips/${tripId}/timeline`);
}
